const nl2br = (text?: string): string => {
  if (text) {
    return text.replace(new RegExp(`\r?\n`, "g"), "<br />");
  }
  return "";
};

export default nl2br;
